import './polyfills.js';
import moment from 'moment';

import AlertBar from './components/AlertBar/index.js';
import Breadcrumbs from './components/Breadcrumbs/index.js';
import Button from './components/Button/index.js';
import ButtonGroup from './components/ButtonGroup/index.js';
import Card from './components/Card/index.js';
import ChoiceTiles from './components/ChoiceTiles/index.js';
import Collection from './components/Collection/index.js';
import Datagrid from './components/Datagrid/index.js';
import DateTime from './components/DateTime/index.js';
import DateTimePicker from './components/DateTimePicker/index.js';
import Dropdown from './components/Dropdown/index.js';
import Form from './components/Form/index.js';
import Grid from './components/Grid/index.js';
import KeyValuePair from './components/KeyValuePair/index.js';
import Link from './components/Link/index.js';
import MonthPicker from './components/MonthPicker/index.js';
import Navigation from './components/Navigation/index.js';
import Page from './components/Page/index.js';
import PaginationControls from './components/PaginationControls/index.js';
import Pill from './components/Pill/index.js';
import Popover from './components/Popover/index.js';
import Table from './components/Table/index.js';
import Tabset from './components/Tabset/index.js';
import Tooltip from './components/Tooltip/index.js';
import Modal from './components/Modal/index.js';
import { context } from './context.js';
import configuration from './configuration.js';
import translations from './translations/index.js';
import './index.less';

import 'moment/locale/ja.js';
moment.locale(translations.resolveLocale());

export default {
  configuration,
  translations,
  context,
  AlertBar,
  Breadcrumbs,
  Button,
  ButtonGroup,
  Card,
  ChoiceTiles,
  Collection,
  Datagrid,
  DateTime,
  DateTimePicker,
  Dropdown,
  Form,
  Grid,
  KeyValuePair,
  Link,
  MonthPicker,
  Navigation,
  Page,
  PaginationControls,
  Pill,
  Popover,
  Table,
  Tabset,
  Tooltip,
  Modal
};

export {
  configuration,
  translations,
  context,
  AlertBar,
  Breadcrumbs,
  Button,
  ButtonGroup,
  Card,
  ChoiceTiles,
  Collection,
  Datagrid,
  DateTime,
  DateTimePicker,
  Dropdown,
  Form,
  Grid,
  KeyValuePair,
  Link,
  MonthPicker,
  Navigation,
  Page,
  PaginationControls,
  Pill,
  Popover,
  Table,
  Tabset,
  Tooltip,
  Modal
};
